import { render, staticRenderFns } from "./bankAccountRemove.vue?vue&type=template&id=67d08e81&scoped=true&"
import script from "./bankAccountRemove.vue?vue&type=script&lang=js&"
export * from "./bankAccountRemove.vue?vue&type=script&lang=js&"
import style0 from "./bankAccountRemove.vue?vue&type=style&index=0&id=67d08e81&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67d08e81",
  null
  
)

export default component.exports